import React from 'react'
import { slide as Menu } from 'react-burger-menu'
import Helmet from 'react-helmet'
import { Link as ScrollLink } from 'react-scroll'
import Slider from 'react-slick'
import iconMenu from '../images/burger.svg'
import competitiveIcon1 from '../images/icon-competitive-1.svg'
import competitiveIcon2 from '../images/icon-competitive-2.svg'
import competitiveIcon3 from '../images/icon-competitive-3.svg'
import competitiveIcon4 from '../images/icon-competitive-4.svg'
import digitalizationIcon from '../images/icon-digitalization.svg'
import imgMarko from '../images/marko-600.jpg'
import imgPresentation1 from '../images/presentations/6-challenges-for-ceos.jpg'
import imgPresentation4 from '../images/presentations/9-roadblocks.jpg'
import imgPresentation3 from '../images/presentations/digital-due-diligence.jpg'
import imgPresentation2 from '../images/presentations/thoughts-on-digitization.jpg'
import aconLogo from '../images/references/acon.jpg'
import carrotLogo from '../images/references/carrot.png'
import corehwLogo from '../images/references/corehw.png'
import dietaLogo from '../images/references/dieta.svg'
import granoLogo from '../images/references/grano.svg'
import helvarLogo from '../images/references/helvar.svg'
import huhtamakiLogo from '../images/references/huhtamaki.svg'
import kulmiaLogo from '../images/references/kulmia.png'
import marinekauppaLogo from '../images/references/marinekauppa.png'
import megaklinikkaLogo from '../images/references/megaklinikka.svg'
import panostajaLogo from '../images/references/panostaja.svg'
import rambollLogo from '../images/references/ramboll.svg'
import selogLogo from '../images/references/selog.png'
import reportCover from '../images/report-cover.png'
import Header from '../layouts/header'

const Head = () => (
  <div>
    <Menu right customBurgerIcon={ <img src={iconMenu} /> }>
      <ScrollLink className="menu-item" activeClass="active" to="top" spy={true} smooth={true} duration={500}>
        Main
      </ScrollLink>
      <ScrollLink className="menu-item" activeClass="active" to="digitalization" spy={true} smooth={true} duration={500}>
        What digitalization is
      </ScrollLink>
      <ScrollLink className="menu-item" activeClass="active" to="we-serve" spy={true} smooth={true} duration={500}>
        Our customers
      </ScrollLink>
      <ScrollLink className="menu-item" activeClass="active" to="digital-expert" spy={true} smooth={true} duration={500}>
        Digital Expert
      </ScrollLink>
      <ScrollLink className="menu-item" activeClass="active" to="references" spy={true} smooth={true} duration={500}>
        References
      </ScrollLink>
      <ScrollLink className="menu-item" activeClass="active" to="contact" spy={true} smooth={true} duration={500}>
        Contact info
      </ScrollLink>
    </Menu>
    <Helmet
      title="Ajantasalla - Your advisor in digitalization"
      meta={[
        { name: 'description', content: 'Are you ready to win digital economy? We are your advisor in digitalization.' },
      ]}
    />
    <Header />
  </div>
)

const Hero = () => (
  <div className="hero">
    <div className="grid-container grid-container-padded">
      <div className="grid-x">
        <div className="medium-7 large-5 medium-offset-3 cell text-center">
          <h1>Are you ready to win in the digital economy?</h1>
          <h3>We are your advisor in digitalization</h3>
        </div>
      </div>
    </div>
  </div>
)

const trackDownload = () => {
  ReactGA.event({
    category: 'download',
    action: 'When hype fades and it\'s back to reality',
  });
}

const ReportBanner = () => (
  <section style={{paddingBottom: 0}} className="report-banner">
    <div className="grid-container grid-container-padded">
      <div className="grid-x">
        <div className="medium-3 large-2 large-offset-2 cell image-container">
          <img src={reportCover} />
        </div>
        <div className="medium-9 large-6 cell text-center">
          <h3>WHEN HYPE FADES AND IT'S BACK TO REALITY</h3>
          <p style={{fontFamily: '"Bree Serif", serif', fontSize: '1.25rem', color: '#1fa7ca'}}>
            Read how seasoned executives see digitalization impacting leadership, the leadership team and the board
          </p>
          <a className="button secondary radius" href="/when-the-hype-fades-report-on-digitalization-ajantasalla.pdf" onClick={trackDownload}>
            Download report
          </a>
          <hr/>
        </div>
      </div>
    </div>
  </section>
)

const Digitalization = () => (
  <section className="digitalization" id="digitalization">
    <h1 className="text-center">Digitalization is...</h1>
    <h3 className="text-center">Building growth and competitive edge with digital technology</h3>
    <div className="grid-container grid-container-padded">
      <div className="grid-x grid-margin-x align-middle text-center">
        <div className="small-12 large-auto cell">
          <p>
            CEO's modern toolbox for better strategies and more efficient execution.
          </p>
          <hr/>
          <p>Leadership challenge, not a technology problem.</p>
        </div>
        <div className="small-12 large-auto cell">
          <img src={digitalizationIcon} style={{padding: '0 5rem'}} />
        </div>
        <div className="small-12 large-auto cell">
          <p>
            A transition to digital economy, not an IT-project or separate strategy.
          </p>
          <hr/>
          <p>
            Industries are transforming, companies must follow.
          </p>
        </div>
      </div>
    </div>
  </section>
)

const Services = () => (
  <section className="services" id="expertise">
    <h1 className="text-center">Build competitive edge with digitalization</h1>
    <div className="grid-container grid-container-padded">
      <div className="grid-x grid-margin-x large-up-2">
        <div className="cell">
          <div className="grid-x align-bottom">
            <div className="small-3 cell">
              <img src={competitiveIcon1} />
            </div>
            <div className="small-7 cell">
              <h3>1</h3>
              <p>Make your products and services smarter</p>
            </div>
          </div>
        </div>

        <div className="cell">
          <div className="grid-x align-bottom">
            <div className="small-3 cell">
              <img src={competitiveIcon2} />
            </div>
            <div className="small-7 cell">
              <h3>2</h3>
              <p>Apply new digital business models</p>
            </div>
          </div>
        </div>
          
        <div className="cell">
          <div className="grid-x align-bottom" style={{ marginTop: '1rem' }}>
            <div className="small-3 cell">
              <img src={competitiveIcon3} />
            </div>
            <div className="small-7 cell">
              <h3>3</h3>
              <p>Scale your sales and operations</p>
            </div>
          </div>
        </div>

        <div className="cell">
          <div className="grid-x align-bottom" style={{ marginTop: '1rem' }}>
            <div className="small-3 cell">
              <img src={competitiveIcon4} />
            </div>
            <div className="small-7 cell">
              <h3>4</h3>
              <p>Turn data into a strategic asset</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p className="text-center" style={{marginTop: '3.25rem'}}>
      <a className="button secondary radius" href="mailto:marko.luhtala@ajantasalla.fi?subject=Help needed in digitalization">
        Contact us to learn more
      </a>
    </p>
  </section>
)

const WayOfWorking = () => (
  <section className="way-of-working" id="we-serve">
    <h1>We serve companies who</h1>
    <div className="grid-container grid-container-padded">
      <div className="grid-x grid-margin-x align-stretch text-center">
        <div className="small-12 large-auto cell">
          <div className="circle">
            <h3>Are taking early steps in digitalization</h3>
            <ul className="no-bullet">
              <li>Explain what digitalization means in practice</li>
              <li>Map the digital potential and capabilities</li>
              <li>Build attractive digital vision for the company</li>
              <li>Calculate business case for digitalization</li>
              <li>Help in getting started</li>
            </ul>
          </div>
        </div>
        <div className="small-12 large-auto cell">
          <div className="circle">
            <h3>Face roadblocks or crossroads in the implementation</h3>
            <ul className="no-bullet">
              <li>Analyse the current state of digitalization</li>
              <li>Assess business cases, investments and capabilities</li>
              <li>Ensure unanimous digital vision in the company</li>
              <li>Revise the plans and assist in the execution</li>
            </ul>
          </div>
        </div>
        <div className="small-12 large-auto cell">
          <div className="circle">
            <h3>Want to be global leaders in the digital economy</h3>
            <ul className="no-bullet">
              <li>Develop ideas for achieving radical competitive edge and industry disruption</li>
              <li>Apply AI, IoT and other transformational technologies in building unique customer value</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <a 
      className="button secondary radius" 
      href="mailto:marko.luhtala@ajantasalla.fi?subject=Help needed in digitalization"
      style={{ marginTop: '2rem' }}
    >
      Request a proposal
    </a>
  </section>
)

const Presentations = () => (
  <section className="presentations">
    <div className="grid-container grid-container-padded">
      <div className="grid-x grid-margin-x">
        <div className="auto cell">
          <h3 className="text-center" style={{ marginBottom: '1rem' }}>More about digitalization</h3>
          <div className="grid-x grid-margin-x">
            <div className="medium-auto cell">
              <a href="https://www.slideshare.net/MarkoLuhtala/digitalization-9-practical-roadblocks-on-this-musthave-journey-97901159" target="_new">
                <img src={imgPresentation4} />
              </a>
              <p>Digitalization - 9 practical roadblocks on this must-have journey.</p>
              <a href="https://www.slideshare.net/MarkoLuhtala/digitalization-9-practical-roadblocks-on-this-musthave-journey-97901159" target="_new">
                View presentation
              </a>
            </div>
            <div className="medium-auto cell">
              <a href="https://www.slideshare.net/MarkoLuhtala/leadership-in-the-digital-economy-six-challenges-for-ceos" target="_new">
                <img src={imgPresentation1} />
              </a>
              <p>Leadership in the digital economy. 6 challenges for CEOs.</p>
              <a href="https://www.slideshare.net/MarkoLuhtala/leadership-in-the-digital-economy-six-challenges-for-ceos" target="_new">
                View presentation
              </a>
            </div>
            <div className="medium-auto cell">
              <a href="https://www.slideshare.net/MarkoLuhtala/digital-due-diligence-discover-the-full-potential-of-digitalization" target="_new">
                <img src={imgPresentation3} />
              </a>
              <p>Digital Due Diligence - Discover the full potential of digitalization.</p>
              <a href="https://www.slideshare.net/MarkoLuhtala/digital-due-diligence-discover-the-full-potential-of-digitalization" target="_new">
                View presentation
              </a>
            </div>
            <div className="medium-auto cell">
              <a href="https://www.slideshare.net/MarkoLuhtala/thoughts-on-digitization-65121989" target="_new">
                <img src={imgPresentation2} />
              </a>
              <p>Thoughts on digitalization. What I have learned in 17 years.</p>
              <a href="https://www.slideshare.net/MarkoLuhtala/thoughts-on-digitization-65121989" target="_new">
                View presentation
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

const DigitalExpert = () => (
  <section className="digital-expert" id="digital-expert">
    <h1 className="text-center">Marko Luhtala – your digital expert</h1>
    <div className="grid-container grid-container-padded">
      <div className="grid-x">
        <div className="auto cell">
          <img src={imgMarko} className="marko-img" />
          <h3>
            Marko Luhtala has almost 20 years of experience in digitalization in several 
            industries ranging from retail, consumer electronics, IT and travel to construction 
            and agriculture.
          </h3>
          <p>
            He has a rare background combining international corporate executive experience 
            and technology entrepreneurship. 
          </p>
          <p>
            As an international sales and marketing executive 
            Marko has applied digitalization extensively in his own business operations globally. 
            Later, as a SaaS and digital marketing entrepreneur he has developed digitalization 
            solutions successfully for dozens of client companies. He has also served 
            several fast-growing technology companies as a board member. 
          </p>
          <p>
            Marko’s passion in digitalization 
            is adding unique value to customers, innovative business models, building winning 
            teams and making strategies happen. 
          </p>
        </div>
      </div>
    </div>
  </section>
)

const References = () => (
  <section className="references" id="references">
    <h1>References</h1>
    <Slider dots infinite speed="1000" pauseOnHover arrows>
    <div>
        <img src={huhtamakiLogo} />
        <blockquote>
        As Interim Digital Lead for Huhtamaki, Marko was instrumental in taking our 
        Digital Agenda to the next level. He facilitated shaping the vision, planning 
        roadmap towards the vision and executing on the roadmap across all Huhtamaki 
        businesses and geographies. Marko truly has the other eye on the telescope while 
        the other one is on the microscope. He connected well with everyone in the organization, 
        turned the PowerPoints into reality, and positively impacted our business 
        performance through his pragmatic yet future-oriented approach. On top of that, 
        he is a super fun person to work with! I can highly recommend Marko for interim 
        digital leadership or advisory roles
          <cite>Antti Valtokari, EVP IT and Process Performance & CIO, Huhtamaki Oy</cite>
        </blockquote>
      </div>
      <div>
        <img src={rambollLogo} />
        <blockquote>
          Marko has shown excellent capabilities in helping us to create new business 
          models related to life cycle data management in real estate sector business. 
          Marko has helped us to utilize opportunities which digitalization provides 
          in our field of industry. He is goal oriented and has wide understanding in 
          digitalisation and business development. I warmly recommend to work with Marko 
          to get full advantage from digitalisation in various businesses.
          <cite>Valtter Kari, Managing Director, Ramboll CM Oy</cite>
        </blockquote>
      </div>
      <div>
        <img src={granoLogo} />
        <blockquote>
          Grano's industry is in the middle of digital disruption that we are planning to win. 
          Marko has helped our board and management team in sharpening the common digital vision 
          and in understanding how to make it happen. Besides Marko's deep knowledge of digital 
          strategies we appreciate his pragmatic experience on the leadership challenges of digitalization. 
          I hope to continue working with Marko in the future! 
          <cite>Jukka-Pekka Vuori, Chief Commercial Officer Grano Oy</cite>
        </blockquote>
      </div>
      <div>
        <img src={aconLogo} />
        <blockquote>
        Marko Luhtala was endorsed us to facilitate Acon´s strategic change. 
        Marko´s straightforward and timely way to carry out the project in a relatively short time impressed me. 
        Marko´s ability to keep every member involved in the project regardless of everyone´s daily chores 
        was mesmerizing - his input and "out of box" innovative ideas to the strategy itself and the way 
        how to execute it was found really helpful by our team. Marko proved himself being capable of offering 
        valuable input regardless of industry and company size - thanks to his entrepreneurial background!
        <cite>Tarmo Sallinen, CEO, Acon Oy</cite>
        </blockquote>
      </div>
      <div>
        <img src={marinekauppaLogo} />
        <blockquote>
          Marko has a deep understanding of digital businesses and growth strategies. 
          His help in facilitating our next generation e-commerce strategy work was 
          done with a result driven approach and a positive attitude. I can warmly 
          recommend him as a hands-on digital business sparring partner.
          <cite>Mats Wolontis, Chairman, Marinekauppa.com</cite>
        </blockquote>
      </div>
      <div>
        <img src={dietaLogo} />
        <blockquote>
          We co-created ideas for digitized Dieta-future with Marko. 
          His coaching in the process was vital for the right mindset & attitude 
          towards the "limitless future". Marko's ability to support innovative 
          but realistic brain storming is laudable thanks to his know-how, 
          experience and strategic comprehension. We look forward to continuing 
          working with Marko!
          <cite>Juhani Järvenpää, CEO Dieta Group Oy</cite>
        </blockquote>
      </div>
    </Slider>
  </section>
)

const LogoMatrix = () => (
  <section className="logo-matrix">
    <div className="grid-container grid-container-padded">
      <div className="grid-x grid-margin-x large-up-4 small-up-3 align-middle">
        <div className="auto cell">
          <img src={huhtamakiLogo} />
        </div>
        <div className="cell">
          <img src={rambollLogo} />
        </div>
        <div className="cell">
          <img src={panostajaLogo} />
        </div>
        <div className="cell">
          <img src={granoLogo} />
        </div>
        <div className="cell">
          <img src={megaklinikkaLogo} />
        </div>
        <div className="cell">
          <img src={dietaLogo} />
        </div>
        <div className="cell">
          <img src={carrotLogo} />
        </div>
        <div className="cell">
          <img src={selogLogo} />
        </div>
        <div className="cell">
          <img src={corehwLogo} />
        </div>
        <div className="cell">
          <img src={kulmiaLogo} />
        </div>
        <div className="cell">
          <img src={marinekauppaLogo} />
        </div>
        <div className="cell">
          <img src={helvarLogo} />
        </div>
        <div className="cell">
          <img src={aconLogo} />
        </div>
      </div>
    </div>
  </section>
)

const Footer = () => (
  <footer id="contact">
    <div className="grid-container grid-container-padded">
      <div className="grid-x grid-margin-x">
        <div className="medium-5 large-auto cell">
          <h1>Ajantasalla</h1>
        </div>
        <div className="medium-auto cell">
          Ajantasalla Yrityspalvelut<br/>
          Tähdenlennontie 63<br/>
          FI-02240 Espoo, Finland<br/>
          Business ID FI22711524
        </div>
        <div className="medium-auto cell">
          Marko Luhtala<br/>
          <a href="mailto:marko.luhtala@ajantasalla.fi">
            marko.luhtala@ajantasalla.fi
          </a><br/>
          <a href="tel:+358503879903">
            +358-50-3879903
          </a>
        </div>
        <div className="medium-shrink cell">
          <a href="https://www.linkedin.com/in/marko-luhtala-07b02321/">
            <svg className="linkedin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path id="linkedin" d="M0 0v24h24v-24h-24zm8 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.397-2.586 7-2.777 7 2.476v6.759z"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </footer>
)

const EnPage = () => (
  <div>
    <Head />
    <Hero />
    <ReportBanner />
    <Digitalization />
    <Presentations/>
    <WayOfWorking />
    <Services />
    <DigitalExpert />
    <References />
    <LogoMatrix />
    <Footer />
  </div>
)

export default EnPage



// WEBPACK FOOTER //
// ./src/pages/en.js